import tw from 'twin.macro';

export const Wrapper = tw.div`m-auto py-6 px-6 md:px-20 flex justify-between max-w-screen-xl`;

export const CookieContent = tw.p`m-auto`;

export const Background = tw.div`bg-black text-white font-body w-full fixed bottom-0 left-0 z-40 md:text-base text-xs sm:text-sm`;
